import { render, staticRenderFns } from "./BrandTile.vue?vue&type=template&id=b2c9f23a&scoped=true&"
import script from "./BrandTile.vue?vue&type=script&lang=js&"
export * from "./BrandTile.vue?vue&type=script&lang=js&"
import style0 from "./BrandTile.vue?vue&type=style&index=0&id=b2c9f23a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c9f23a",
  null
  
)

export default component.exports